import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

const LoginScreen = () => {

  console.log("------------------loginscreen rendered----------------------");

  const auth = useAuth();

  const handleLogin = () => {
    const params = new URLSearchParams(window.location.search);
    const redirectTo = params.get('redirectTo') || '/';
    localStorage.setItem('MEsightIATpostLoginRedirect', redirectTo);
    auth.signinRedirect();
  };
  // Log authentication state for debugging
  console.log("Auth state:", {
    isLoading: auth.isLoading,
    isAuthenticated: auth.isAuthenticated,
    activeNavigator: auth.activeNavigator,
    error: auth.error,
    state: window.localStorage.getItem("oidc.some_random_string"),
  });
  
  // If already authenticated, redirect to home
  if (auth.isAuthenticated) {
    const redirectTo = localStorage.getItem('MEsightIATpostLoginRedirect') || '/';
    localStorage.removeItem('MEsightIATpostLoginRedirect');
    return <Navigate to={redirectTo} replace />;
  }
  
  // If auth is in progress, show loading
  if (auth.isLoading || auth.activeNavigator) {
    return <div>Loading authentication...</div>;
  }
  
  // If there was an error, show it
  if (auth.error) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        <h1>Authentication error: {auth.error.message}</h1>
        <p>Please sign in again</p>
        <button onClick={handleLogin}
          className="px-6 py-2 bg-black text-white font-semibold text-2xl rounded-lg shadow hover:bg-gray-800 transition duration-200"
        >
          Sign In
        </button>
      </div>
    );
  }
  
  // Otherwise show login button
  return (
    <div className="login-container flex flex-col items-center justify-center h-screen bg-gray-100">
      <h1 className="text-5xl text-gray-800 font-medium mb-20">Welcome to the MEsight</h1>
      <button onClick={handleLogin}
        className="px-6 py-2 bg-black text-white font-semibold text-2xl rounded-lg shadow hover:bg-gray-800 transition duration-200"
      >
        Sign In
      </button>
    </div>
  );
};

export default LoginScreen;